import { appConfig } from "@/config";

export const getResizedImageUrl = (src: string, options: Partial<{
    height: number;
    width: number;
    fit: 'cover' | 'contain';
  }> = {}) => {
  if (!src) return '';
  const isDev = appConfig.NEXT_PUBLIC_API_BASE_URL.includes('dev');
  const base = new URL(isDev ? `https://cdn.dev.foochia.io/cdn-cgi/image/` : `https://cdn.foochia.com/cdn-cgi/image/`);
  const {height, width, fit = 'cover'} = options;
  const srcUrl = new URL(src).href;
  base.href += `width=${width}${height ? `,height=${height}` : ''},fit=${fit},gravity=center${srcUrl.startsWith('/') ? '' : '/'}${srcUrl}`;
  return base.href;
}
